export const languageLevels = [
    { id: 1, level: 'Basico' },
    { id: 2, level: 'Intermedio' },
    { id: 3, level: 'Avanzado' },
    { id: 4, level: 'Nativo' }
];
